import React from "react";
import { ReactComponent as CheckIcon } from "./assets/checkmark-filled.svg";
import {
  MissionListFooterButtonsContainer,
  MissionListFooterCheckmarkIcon,
  MissionListFooterContainer,
  MissionListFooterPrimaryButton,
  MissionListFooterSecondaryButton,
} from "Components/DeployedMissionList/components/MissionListFooter/styles";

interface MissionListFooterProps {
  onGoBack?: () => void;
  onCreateMission?: () => void;
}

export const MissionListFooter: React.FC<MissionListFooterProps> = ({
  onGoBack,
  onCreateMission,
}) => {
  return (
    <MissionListFooterContainer>
      <MissionListFooterButtonsContainer>
        <MissionListFooterSecondaryButton onClick={onGoBack}>
          Go Back
        </MissionListFooterSecondaryButton>
        <MissionListFooterPrimaryButton onClick={onCreateMission}>
          Create Mission
          <MissionListFooterCheckmarkIcon>
            <CheckIcon />
          </MissionListFooterCheckmarkIcon>
        </MissionListFooterPrimaryButton>
      </MissionListFooterButtonsContainer>
    </MissionListFooterContainer>
  );
};
